// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"TX-z","sponsoredTooltipWrapper":"UX-z","sponsoredTooltip":"VX-z","newCard":"WX-z"};